<template>
  <tip-tap-input v-model="internalValue" :fields="collectionFields" />
</template>

<script>
  import { useAppStore } from "@/stores/appStore";

  export default {
    name: "ImageSelect",
    props: {
      modelValue: [Object, String],
      required: Boolean,
      rules: {
        type: Array,
        default: () => [],
      },
    },

    computed: {
      internalValue: {
        get() {
          return this.modelValue;
        },
        set(val) {
          this.$emit("update:modelValue", val);
        },
      },
      collectionFields() {
        return this.appStore.fields;
      },

      appStore() {
        return useAppStore();
      },
    },

    methods: {
      onUpdate(val) {
        this.$emit("update:modelValue", val);
        this.internalValue = val;
      },
    },
  };
</script>
